import { makeStyles } from 'tss-react/mui'
import { lato, nunito_sans } from '@styles/fonts'

const useStyles = makeStyles()((theme) => ({
  root: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100vw',
    height: 'auto',
    padding: theme.spacing(15, 2, 2, 2),
    backgroundColor: theme.custom.blackColor,
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    overflow: 'scroll',
    zIndex: 999999,
  },
  closeIcon: {
    position: 'absolute',
    right: '2.63%',
    top: '5.1%',
    cursor: 'pointer',
  },
  innerContainer: {
    width: '100vw',
    height: 'inherit',
    maxWidth: theme.maxWidth,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  textContainer: {
    width: '100%',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  heading: {
    fontFamily: nunito_sans.style.fontFamily,
    fontStyle: 'normal',
    fontWeight: 800,
    fontSize: '32px',
    lineHeight: '44px',
    textAlign: 'center',
    textTransform: 'uppercase',
    color: theme.custom.lightFont,
    marginBottom: theme.spacing(4),
  },
  subHeading: {
    width: '100%',
    maxWidth: '604px',
    height: '48px',
    fontFamily: lato.style.fontFamily,
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '20px',
    lineHeight: '24px',
    color: theme.custom.lightFont,
    opacity: 0.7,
  },
  topicBtnContainer: {
    width: '100%',
    margin: theme.spacing(16.25, 0, 11.25, 0), // ? exact val as figma
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    flexWrap: 'wrap',
    [theme.breakpoints.down('md')]: {
      margin: theme.spacing(16.25, 2.5), // ? exact val as figma
    },
  },
  topicButton: {
    '> *': {
      color: 'red !important',
    },
    margin: theme.spacing(2.25),
    [theme.breakpoints.down('md')]: {
      margin: theme.spacing(1.5),
    },
  },
  continueBtnContainer: {
    width: '100%',
    height: '100%',
    display: 'grid',
    placeContent: 'center',
  },
  continueBtn: {
    placeContent: 'center',
    padding: theme.spacing(3.5, 6.5),
    height: '50px',
    background: theme.custom.whiteColor,
    borderRadius: '130px',
    cursor: 'pointer',
  },
  selectedTopicsBtn: {
    color: 'red',
    '& .btnInnerContainer': {
      backgroundColor: 'white',
    },
  },
}))

export default useStyles
